export default "__VITE_ASSET__DJgAYSqi__"